import { Image } from "./image.component";
import selfImage from "../assets/erfanshokouhi.jpg";
import { Row } from "./row.component";
import ToggleThemeButton from "./toggle-theme-button.component";
export const Header = (props) => {
  const publicationDate = "12 Dec, 2024";
  const birthDate = "12 Aug, 1996";

  return (
    <header className="bg-gray-50 sticky top-0 z-50 h-[113px] dark:bg-gray-800 border-b border-b-gray-200 dark:border-gray-700 flex flex-row items-center justify-between h-22 p-4 gap-2">
      <Row>
        <Image src={selfImage} rounded="full" size="xl" className="flex-0" />
        <Row direction="col" items="start" justify="start">
          <h1 className="text-xl sm:text-3xl font-semibold dark:text-gray-50">
            Erfan Shokouhi
          </h1>
          <span className="text-gray-400 text-sm">{birthDate}</span>
        </Row>
      </Row>

      <h2 className="text-sm sm:text-2xl font-regular flex-1 flex flex-col items-center justify-end lg:flex-row lg:gap-2 dark:text-gray-50 gap-1">
      
        <span>Published at</span>
        <ToggleThemeButton
          isOn={props.theme === "dark"}
          handleToggle={() =>
          {
            props.setTheme(props.theme === "dark" ? "light" : "dark")
            localStorage.setItem('theme',props.theme === "dark" ? "light" : "dark")
          }
          }
        />
        <span className="font-semibold">{publicationDate}</span>
       
      </h2>
    </header>
  );
};
